import React from 'react';

import edit from '@amzn/meridian-tokens/base/icon/edit';
import menuTokens from '@amzn/meridian-tokens/base/icon/menu';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { type RegionTask } from 'src/services/tasks/types';

import { ROW_LAYOUT } from '../constants';

const SortableRegionTaskRow = (props: { task: RegionTask }) => {
  const { task, ...otherProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: task.taskId,
    animateLayoutChanges: () => false,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className="sortable-region-task-row"
      style={style}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      {...otherProps}
    >
      <Row widths={ROW_LAYOUT} width="100%" spacingInset={'none'}>
        <Text className="form-tasks-table__text">
          <Icon tokens={menuTokens} />
        </Text>
        <Text className="form-tasks-table__text">{task.rank == null ? 'Not Ranked' : task.rank}</Text>
        <Text className="form-tasks-table__text">{task.label}</Text>
        <Text className="form-tasks-table__text">{task.identifyBodyLocation ? 'Yes' : 'No'}</Text>
        <Text className="form-tasks-table__text">{task.measureUnit || ''}</Text>
        <Text className="form-tasks-table__text">{task.description || ''}</Text>
        <Text className="form-tasks-table__text">{task.modifications.length || 0}</Text>
        <Button type="icon" aria-label="Edit">
          <Icon tokens={edit} />
        </Button>
      </Row>
    </div>
  );
};

export default SortableRegionTaskRow;
